import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { css } from 'emotion';
import PropTypes from 'prop-types';
import { colors, Toggle } from '@cimpress/react-components';
import { Spinner } from '@cimpress/react-components/lib/shapes';
import { connect } from 'react-redux';
import { selectors as configSelectors } from '../../../reducers/configurations';

const toggleStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  borderTop: `2px solid ${colors.alloy}`,
  padding: '20px 0px'
});

class ApprovalToggle extends PureComponent {
  static propTypes = {
    partyId: PropTypes.string.isRequired,
    partyType: PropTypes.string.isRequired,
    partyName: PropTypes.string.isRequired,
    autoApprove: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired
  };

  onChangeApproval = () => {
    const { partyId, onToggle } = this.props;
    return onToggle(partyId);
  };

  render() {
    const { t, partyName, autoApprove, isUpdatingConfigurations } = this.props;

    return (
      <div className={toggleStyle}>
        <b>{partyName}</b>
        {isUpdatingConfigurations ? (
          <Spinner size={35} />
        ) : (
          <Toggle
            on={autoApprove}
            onClick={this.onChangeApproval}
            onText={t('common:commonWords.onText')}
            offText={t('common:commonWords.offText')}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isUpdatingConfigurations: configSelectors.getIsUpdatingConfigurations(state)
});

export default connect(mapStateToProps)(withTranslation()(ApprovalToggle));
